export abstract class TimeUtil {
  static readonly MINUTE_SECONDS = 60;
  static readonly HOUR_SECONDS = 60 * this.MINUTE_SECONDS;

  static readonly SECOND_MILLIS = 1000;
  static readonly MINUTE_MILLIS = 60 * this.SECOND_MILLIS;
  static readonly HOUR_MILLIS = 60 * this.MINUTE_MILLIS;

  /** Convert a span of time into seconds. */
  static toSeconds(options: { hours?: number, minutes?: number, seconds?: number }) {
    const hours = options?.hours ?? 0;
    const minutes = options?.minutes ?? 0;
    const seconds = options?.seconds ?? 0;
    return hours * this.HOUR_SECONDS + minutes * this.MINUTE_SECONDS + seconds;
  }

  /** Convert a span of time into milliseconds. */
  static toMilliseconds(options: { hours?: number, minutes?: number, seconds?: number, millis?: number }) {
    const hours = options?.hours ?? 0;
    const minutes = options?.minutes ?? 0;
    const seconds = options?.seconds ?? 0;
    const millis = options?.millis ?? 0;
    return hours * this.HOUR_MILLIS + minutes * this.MINUTE_MILLIS + seconds * this.SECOND_MILLIS + millis;
  }

  /**
   * Get a promise that resolves after `ms` milliseconds.
   *
   * @param ms The time to wait before the promise resolves.
   */
  static wait<T>(ms: number, returnValue: T = undefined): Promise<T> {
    return new Promise(resolve => {
      setTimeout(() => {
        resolve(returnValue);
      }, ms);
    })
  }
}
